<template>
  <div class="mx-auto max-w-4xl bg-white my-12">
    <div class="flex items-start">
      <template v-for="(step, index) in steps" :key="step.id">
        <!-- Step -->
        <div class="flex flex-1 flex-col items-center">
          <div
            :class="[
              'flex h-9 w-9 items-center justify-center rounded-full text-sm font-semibold',
              step.id < currentStep
                ? 'bg-green-600 text-white'
                : step.id === currentStep
                ? 'bg-zinc-200 text-zinc-500'
                : 'bg-zinc-200 text-zinc-500',
            ]"
          >
            <span v-if="step.id < currentStep">✓</span>
            <span v-else>{{ step.id }}</span>
          </div>

          <span class="mt-2 w-24 text-center text-xs font-medium text-zinc-700">
            {{ step.title }}
          </span>
        </div>

        <!-- Connecting Line -->
        <div
          v-if="index < steps.length - 1"
          class="mt-4 h-0.5 flex-1"
          :class="step.id < currentStep ? 'bg-green-600' : 'bg-zinc-200'"
        ></div>
      </template>
    </div>
  </div>

  <!-- Activity -->
  <div class="mt-8">
    <div class="mb-5">
      <h3 class="text-lg font-semibold text-secondary">Recent Activity</h3>
      <p class="text-sm text-zinc-500">
        View the latest updates regarding your payment and membership renewal.
      </p>
    </div>

    <div class="space-y-4">
      <div
        v-for="activity in activities"
        :key="activity.title"
        class="rounded-2xl border border-zinc-200 bg-white p-5 transition-all duration-200 hover:border-zinc-300 hover:shadow-md"
      >
        <div class="flex items-start justify-between gap-4">
          <div class="flex flex-1 items-start gap-4">
            <!-- Icon -->

            <div>
              <h4 class="font-semibold text-secondary">
                {{ activity.title }}
              </h4>

              <p class="mt-1 text-sm leading-6 text-zinc-600">
                {{ activity.description }}
              </p>
            </div>
          </div>

          <div class="text-right">
            <p class="text-xs font-medium text-zinc-500">
              {{ activity.date }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const currentStep = ref(2);

const steps = ref([
  { id: 1, title: "Payment Submitted" },
  { id: 2, title: "Payment Processing" },
  { id: 3, title: "Payment Completed" },
]);

const activities = ref([
  {
    title: "Payment Placed",
    date: "Jul 10, 2026 • 3:26 PM",
    description:
      "Thank you for your payment. Your transaction is now being securely processed by our trusted payment partner.",
  },
]);
</script>
